var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _MedicalImagingRefundedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import JournalEvent from "./refunded-journal-event";

//---- Automatically generated, don't update this part ----
/**
 * Describe "RD" (actes de radiologie) reimbursement.
 * Property descriptions are sometimes copy/pasted from the DMP specification.
 *
 * @see sel-mp-005_hr-integre-lps_v-1.9.pdf for details.
 *
 * The DMP feed provides a list of "execution", or reimbursement, each execution
 * has a list of "Acte Facturé" or "Prestation facturée".
 *
 * The medical-act-refunded represents one "Acte facturé" or "Prestation
 * facturée". They are represented as OMOP PROCEDURE_OCCURRENCEs.
 */
let MedicalImagingRefundedJournalEvent = (_dec = attr(), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("string"), _dec7 = attr("number"), _dec8 = attr("performer"), _dec9 = belongsTo("patient", {
  async: false,
  inverse: "medicalImagingRefundedJournalEvents"
}), _class = (_MedicalImagingRefundedJournalEvent = class MedicalImagingRefundedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "hospitalisation", _descriptor, this);
    /**
     * Nature du risque au titre duquel la prestation est prise en charge.
     * Valeurs possibles : «MALADIE», «MATERNITE», «ACCIDENT», «TRAVAIL»,
     * «PREVENTION»
     */
    _initializerDefineProperty(this, "risk", _descriptor2, this);
    /**
     * Valeur = «ALD» si présente
     */
    _initializerDefineProperty(this, "exemption", _descriptor3, this);
    /**
     * CCAM for "Acte facturé"
     * NGAP for "Prestation facturée"
     */
    _initializerDefineProperty(this, "procedureSourceConcept", _descriptor4, this);
    /**
     * The value depends on the concept.
     */
    _initializerDefineProperty(this, "procedureSourceValue", _descriptor5, this);
    /**
     * Libellé de l'acte ou de la série d'actes.
     *
     * En CCAM, on prend le libellé court. Exemple : " panst chir brûlure sf
     * tête/moins 1% corps»
     *
     * En NGAP, on utilise le même libellé que la norme B2
     */
    _initializerDefineProperty(this, "procedureSourceLabel", _descriptor6, this);
    /**
     * Uniquement pour les prestation facturées
     * Cotation de l’acte. Valeur par défaut = «1»
     */
    _initializerDefineProperty(this, "coefficient", _descriptor7, this);
    _initializerDefineProperty(this, "performer", _descriptor8, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor9, this);
  }
  static validations(intl) {
    return {
      reimbursementsRetrievedJournalEvent: validatePresence({
        presence: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.reimbursements-retrieved-journal-event")
      }),
      procedureSourceConcept: [validatePresence({
        presence: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.procedure-source-concept")
      }), validateInclusion({
        list: ["CCAM", "NGAP", "DMP"],
        description: intl.t("validations.medical-imaging-refunded-journal-event.procedure-source-concept")
      })],
      procedureSourceValue: validatePresence({
        presence: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.procedure-source-value")
      }),
      procedureSourceLabel: validatePresence({
        presence: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.procedure-source-label")
      }),
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.medical-imaging-refunded-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      coefficient: validateNumber({
        allowBlank: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.coefficient")
      }),
      risk: validateInclusion({
        list: ["MALADIE", "MATERNITE", "ACCIDENT", "TRAVAIL", "PREVENTION"],
        allowBlank: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.risk")
      }),
      exemption: validateInclusion({
        list: ["ALD"],
        allowBlank: true,
        description: intl.t("validations.medical-imaging-refunded-journal-event.exemption")
      })
    };
  }
}, _defineProperty(_MedicalImagingRefundedJournalEvent, "type", "medical-imaging-refunded-journal-event"), _MedicalImagingRefundedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "hospitalisation", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "risk", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "exemption", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "procedureSourceConcept", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "procedureSourceValue", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "procedureSourceLabel", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "coefficient", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "performer", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicalImagingRefundedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.